import { render } from "./MainPointInsights.vue?vue&type=template&id=65e83f90"
import script from "./MainPointInsights.vue?vue&type=script&lang=js"
export * from "./MainPointInsights.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MainPointInsights.vue"]])

export default __exports__